/**
 * @see https://laravel-news.com/building-flexible-axios-clients
 */

import axios from 'axios';

const base_api = () => {

    /**
     * We are setting up our own Axios instance here so need to duplicate the code frm bootstrap.js
     * so that we attach the CSRF token to the requests
     */
    const axiosInstance = axios.create({
        headers: {
            Accept: 'application/json',
        },
    });

    axiosInstance.interceptors.request.use(async config => {
        config.headers = config.headers ?? {};
        console.log('config headers', config.headers)

        // @see https://stackoverflow.com/questions/62450899/property-content-does-not-exist-on-type-htmlelement-in-typescript
        const apiDomain  = document.head.querySelector('meta[name="api-domain"]');


        if (apiDomain instanceof HTMLMetaElement) {
            config.baseURL = `https://${apiDomain.content}/`;
            console.log('base api domain', { domain: apiDomain.content })
        }

        const token = document.head.querySelector('meta[name="csrf-token"]');

        if (token instanceof HTMLMetaElement) {
            console.log('setting token', { token: token.content })
            config.headers['X-CSRF-TOKEN'] = token.content;
        } else {
            console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
        }
        console.log('amended config', config)

        return config;
    });
    
    /**
     * Return the response of reject the promise on error
     */
    axiosInstance.interceptors.response.use(
        response => {
            console.log('API Response: ', JSON.stringify({ status: response.status, statusText: response.statusText, data: response.data}))
            return response
        },
        async (error) => {
            console.log('API Error: ', error.message )
            return Promise.reject(error);
        },
    );
    
    return axiosInstance;
};

export default base_api();